import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useTranslation } from "react-i18next";

export default function PrivacyPolicyPage() {
  const { t } = useTranslation(["common", "dashboard", "members", "trainers", "reservations", "settings", "payments", "rooms", "messaging", "business", "memberDashboard"]);

  return (
    <div className="min-h-screen bg-slate-50">
      {/* Header */}
      <header className="sticky top-0 z-50 bg-white shadow-sm">
        <div className="container mx-auto px-4 py-4 flex items-center gap-4">
          <Link to="/" className="flex items-center gap-2 text-grey hover:text-navy transition-colors">
            <ArrowLeft className="w-5 h-5" />
            <span>{t('common:back')}</span>
          </Link>
          <h1 className="font-heading font-bold text-lg text-navy">{t("common:privacyPolicy")}</h1>
        </div>
      </header>

      <div className="container mx-auto px-4 py-8 max-w-4xl">
        <div className="bg-white rounded-2xl shadow-sm p-6 md:p-10">
          <h1 className="font-heading text-3xl font-bold text-navy mb-2">{t("common:privacyPolicy")}</h1>
          <p className="text-grey mb-8">Son güncelleme: Şubat 2026</p>

          <div className="prose prose-slate max-w-none">
            <h2 className="font-heading text-xl font-semibold text-navy mt-8 mb-4">1. Giriş</h2>
            <p className="text-grey leading-relaxed mb-4">
              PBStudio ("biz", "bizim" veya "Platform") olarak, kullanıcılarımızın gizliliğine büyük önem veriyoruz. 
              Bu Gizlilik Politikası, kişisel verilerinizin nasıl toplandığını, kullanıldığını ve korunduğunu açıklamaktadır.
            </p>

            <h2 className="font-heading text-xl font-semibold text-navy mt-8 mb-4">2. Toplanan Bilgiler</h2>
            <p className="text-grey leading-relaxed mb-4">Aşağıdaki bilgileri toplayabiliriz:</p>
            <ul className="list-disc list-inside text-grey mb-4 space-y-2">
              <li><strong>Kimlik Bilgileri:</strong> Ad, soyad, e-posta adresi, telefon numarası</li>
              <li><strong>Hesap Bilgileri:</strong> Kullanıcı adı, şifre (şifrelenmiş)</li>
              <li><strong>İşletme Bilgileri:</strong> İşletme adı, adresi, çalışma saatleri, hizmet türleri</li>
              <li><strong>Konum Bilgileri:</strong> İşletme konumu (enlem/boylam)</li>
              <li><strong>Kullanım Verileri:</strong> Uygulama kullanım istatistikleri, cihaz bilgileri</li>
            </ul>

            <h2 className="font-heading text-xl font-semibold text-navy mt-8 mb-4">3. Bilgilerin Kullanımı</h2>
            <p className="text-grey leading-relaxed mb-4">Toplanan bilgiler aşağıdaki amaçlarla kullanılır:</p>
            <ul className="list-disc list-inside text-grey mb-4 space-y-2">
              <li>Hesap oluşturma ve yönetimi</li>
              <li>Hizmetlerimizi sunma ve iyileştirme</li>
              <li>İşletme ve antrenör eşleştirmeleri</li>
              <li>Rezervasyon ve randevu yönetimi</li>
              <li>Müşteri desteği sağlama</li>
              <li>Bildirim gönderme (onayınızla)</li>
            </ul>

            <h2 className="font-heading text-xl font-semibold text-navy mt-8 mb-4">4. Bilgi Paylaşımı</h2>
            <p className="text-grey leading-relaxed mb-4">
              Kişisel bilgilerinizi üçüncü taraflarla satmıyoruz. Ancak aşağıdaki durumlarda paylaşım yapılabilir:
            </p>
            <ul className="list-disc list-inside text-grey mb-4 space-y-2">
              <li>Hizmet sağlayıcılarımızla (hosting, analitik)</li>
              <li>Yasal gereklilikler doğrultusunda</li>
              <li>Sizin açık onayınızla</li>
            </ul>

            <h2 className="font-heading text-xl font-semibold text-navy mt-8 mb-4">5. Veri Güvenliği</h2>
            <p className="text-grey leading-relaxed mb-4">
              Verilerinizi korumak için endüstri standardı güvenlik önlemleri uyguluyoruz:
            </p>
            <ul className="list-disc list-inside text-grey mb-4 space-y-2">
              <li>SSL/TLS şifreleme</li>
              <li>Güvenli sunucu altyapısı</li>
              <li>Düzenli güvenlik denetimleri</li>
              <li>Erişim kontrolleri</li>
            </ul>

            <h2 className="font-heading text-xl font-semibold text-navy mt-8 mb-4">6. Çerezler</h2>
            <p className="text-grey leading-relaxed mb-4">
              Platformumuz, kullanıcı deneyimini iyileştirmek için çerezler kullanır. 
              Oturum çerezleri ve tercih çerezleri kullanılmaktadır.
            </p>

            <h2 className="font-heading text-xl font-semibold text-navy mt-8 mb-4">7. Kullanıcı Hakları</h2>
            <p className="text-grey leading-relaxed mb-4">KVKK kapsamında aşağıdaki haklara sahipsiniz:</p>
            <ul className="list-disc list-inside text-grey mb-4 space-y-2">
              <li>Verilerinize erişim talep etme</li>
              <li>Verilerinizin düzeltilmesini isteme</li>
              <li>Verilerinizin silinmesini talep etme</li>
              <li>Veri işlemeye itiraz etme</li>
              <li>Veri taşınabilirliği</li>
            </ul>

            <h2 className="font-heading text-xl font-semibold text-navy mt-8 mb-4">8. Değişiklikler</h2>
            <p className="text-grey leading-relaxed mb-4">
              Bu Gizlilik Politikası zaman zaman güncellenebilir. 
              Önemli değişiklikler hakkında e-posta veya uygulama içi bildirimlerle bilgilendirileceksiniz.
            </p>

            <h2 className="font-heading text-xl font-semibold text-navy mt-8 mb-4">9. İletişim</h2>
            <p className="text-grey leading-relaxed mb-4">
              Gizlilik politikamız hakkında sorularınız için bizimle iletişime geçebilirsiniz:
            </p>
            <p className="text-grey mb-4">
              <strong>E-posta:</strong> info@pbstudio.com<br />
              <strong>Adres:</strong> İstanbul, Türkiye
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
